import React from 'react';
import { Link } from 'react-router-dom';
import './solutions.css';

const solutions = [
    {
        title: 'Facturación Electrónica',
        icon: 'fables-icondevelopment-icon',
        description: 'Software contable con facturación electrónica integrada. Cumple con la normativa fiscal de manera sencilla y eficiente.',
        cta: 'Ver más →',
        link: '/facturacion-electronica',
        isRoute: true,
        image: '/assets/custom/images/laptop-1209008.jpg',
    },
    {
        title: 'CRM & POS a la medida',
        icon: 'fables-iconcart',
        description: 'Sistemas CRM y punto de venta personalizados para optimizar la gestión de clientes y operaciones de su negocio.',
        cta: 'Contáctenos →',
        link: '/#contactenos',
        image: '/assets/custom/images/mobile-apps.jpg',
    },
    {
        title: 'Automatizaciones con IA',
        icon: 'fables-iconlamp-icon',
        description: 'Automatice procesos repetitivos e impulse la productividad de su empresa con inteligencia artificial.',
        cta: 'Contáctenos →',
        link: '/#contactenos',
        image: '/assets/custom/images/lamp.jpg',
    },
];

const Solutions = () => {
    return (
        <div
            className="solutions-section fables-after-overlay bg-rules py-5 px-3 px-md-0"
            id="solutions"
            style={{ backgroundImage: "url('/assets/custom/images/big-overlay.jpg')" }}
        >
            <div className="container position-relative z-index">
                <div className="text-center mb-5" data-reveal="up">
                    <h2 className="font-30 font-weight-bold white-color">Soluciones de Software</h2>
                    <p className="white-color font-14 mt-2 opacity-75">
                        Herramientas digitales diseñadas para impulsar su negocio
                    </p>
                </div>
                <div className="row">
                    {solutions.map((item, index) => (
                        <div className="col-12 col-md-4 mb-4 mb-md-0" key={index} data-reveal="up" data-reveal-delay={String(index + 1)}>
                            <div className="solution-card lift">
                                <div
                                    className="solution-card-bg"
                                    style={{ backgroundImage: `url(${item.image})` }}
                                />
                                <div className="solution-card-content text-center">
                                    <i className={`${item.icon} white-color mb-3`}></i>
                                    <h4 className="white-color font-weight-bold mb-3">{item.title}</h4>
                                    <p className="white-color mb-4">{item.description}</p>
                                    {item.isRoute ? (
                                        <Link
                                            to={item.link}
                                            className="btn fables-second-background-color white-color px-4 py-2 font-14"
                                        >
                                            {item.cta}
                                        </Link>
                                    ) : (
                                        <a
                                            href={item.link}
                                            className="btn fables-second-background-color white-color px-4 py-2 font-14"
                                        >
                                            {item.cta}
                                        </a>
                                    )}
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default Solutions;
